import React, { useRef, useState } from 'react';
import '../css/custom.css';
import 'bulma-divider/dist/css/bulma-divider.min.css';
import { useReactToPrint } from 'react-to-print';
import ModalReceipt from './ModalReceipt';
import VendingService from '../services/VendingService';
import ResponseParser from '../util/ResponseParser';

export default function Receipt(props) {
   let { title, tokenReceipt } = props;
   const componentRef = useRef();
   const savedUser = JSON.parse(sessionStorage.getItem('user'));
   const [searchedTokenReceipt, setSearchedTokenReceipt] = useState({});

   const printComponent = useReactToPrint({
      content: () => componentRef.current,
      documentTitle: `Receipt-${searchedTokenReceipt.receiptNumber}`,
      copyStyles: true,
   });

   const handlePrint = () => {
      getTokenReceipt();
   };

   const getTokenReceipt = (selectedItem) => {
      let { partnerId } = savedUser;
      // let response = ResponseParser.parseTokenReceiptResponse(xmlReceipt);
      // console.log(response);
      // setType('reprint');
      // dispatch({
      //    type: 'reprint',
      //    payload: {
      //       isModalActive: true,
      //       transactionId: response.transactionId,
      //       tokenReceipt: response,
      //       buttonLabel: 'Print',
      //    },
      // });
      VendingService.getReceipt({
         partnerId,
         transactionId: tokenReceipt.transactionId,
      })
         .then((resp) => resp.text())
         .then((data) => {
            let response = ResponseParser.parseTokenReceiptResponse(data);
            setSearchedTokenReceipt(response);
            printComponent();
            console.log(response);
         })
         .catch((error) => {
            console.log(error);
         });
   };

   return (
      <div className='card'>
         <div className='card-header'>
            <p className='card-header-title is-centered'>{title}</p>
         </div>
         <div className='card-content'>
            <div className='receipt-container'>
               <div className='receipt-viewbox'>
                  <div className='receipt-viewitem is-size-7 has-text-weight-semibold is-uppercase'>
                     Receipt
                  </div>
                  <div className='receipt-item'>{tokenReceipt.receipt}</div>
                  <div className='receipt-viewitem is-size-7 has-text-weight-semibold is-uppercase'>
                     Amount
                  </div>
                  <div className='receipt-item'>{tokenReceipt.purchaseAmount} FRW</div>
                  <div className='receipt-viewitem is-size-7 has-text-weight-semibold is-uppercase'>
                     Units
                  </div>
                  <div className='receipt-item'>{tokenReceipt.units} kWh</div>
                  <div className='receipt-viewitem is-size-7 has-text-weight-semibold is-uppercase'>
                     Tariff
                  </div>
                  <div className='receipt-item'>
                     {tokenReceipt.tariffInfo} / {tokenReceipt.tarrifName}
                  </div>
                  <div className='receipt-viewitem is-size-7 is-uppercase has-text-weight-semibold'>
                     Transaction ID
                  </div>
                  <div className='receipt-item'>{tokenReceipt.transactionId}</div>
                  <div className='receipt-viewitem is-hidden-mobile'></div>
                  <div className='receipt-viewitem is-uppercase is-italic has-text-weight-semibold'>
                     <span className=''>{tokenReceipt.token}</span>
                  </div>
               </div>
            </div>
            <div style={{ display: 'none' }}>
               <ModalReceipt tokenReceipt={searchedTokenReceipt} ref={componentRef} />
            </div>
         </div>
         <footer className='card-footer'>
            <div className='card-footer-item'>
               <button className='button is-link is-white' onClick={handlePrint}>
                  Print
               </button>
            </div>
            <div className='card-footer-item'>
               <button className='button is-link is-rounded'>Add Favorite</button>
            </div>
         </footer>
      </div>
   );
}

// export const EnhancedReceipt = withComponentWrapper(Receipt);
